<template>
  <v-btn @click="printWordStatistic" class="btn-print-word">{{ $t("Печать в Word") }}</v-btn>
</template>

<script>
  export default {
    props: {
      fileName: String,
      htmlTitle: String,
      htmlContent: Object,
    },
    data: () => ({}),
    methods: {
      // печать в ворд статистику исполнения законов
      printWordStatistic() {
        var header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' "+
          "xmlns:w='urn:schemas-microsoft-com:office:word' "+
          "xmlns='http://www.w3.org/TR/REC-html40'>"+
          "<head><meta charset='utf-8'><title>HtmlToWord</title></head><body>" +
          "<style>" +
          "table {width: 100%;display: table;color: #000;border-collapse: collapse;border-spacing: 0;}" +
          "table td {\n" +
          "    position: relative;\n" +
          "    padding: 8px 20px;\n" +
          "    border: 1px solid rgba(0,0,0,.5);\n" +
          "}" +
          "</style>";
        var footer = "</body></html>";
        var sourceHTML = header+this.htmlTitle+this.htmlContent.$el.innerHTML+footer;

        var source = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(sourceHTML);
        var fileDownload = document.createElement("a");
        document.body.appendChild(fileDownload);
        fileDownload.href = source;
        fileDownload.download = this.fileName+'.doc';
        fileDownload.click();
        document.body.removeChild(fileDownload);
      },
    }
  }
</script>
